import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ModuleRolesConstants } from "../components/module-user-roles/module-roles.constants";
import { map } from "rxjs/operators";
import { ApiModuleRoleConstants } from "../../../shared/constants/api-constants/api-module-role.constants";
import { AppRoutingConstants } from "../../../app-routing.constants";
let ModuleRoleService = class ModuleRoleService {
    http;
    moduleRoleUrl = ApiModuleRoleConstants.URL;
    functionGetModuleRolesAndUsers = ApiModuleRoleConstants.FUNCTION_GET_MODULE_ROLES_AND_USERS;
    functionGetModuleRolesAndUsersIncludingSysAdmin = ApiModuleRoleConstants.FUNCTION_GET_MODULE_ROLES_AND_USERS_INCLUDING_SYSADMIN;
    functionGetModuledUsersIncludingSysAdmin = ApiModuleRoleConstants.FUNCTION_GET_MODULE_USERS_INCLUDING_SYSADMIN;
    moduleIdFilter = ModuleRolesConstants.MODULE_ID_FILTER_STRING;
    systemFilter = ModuleRolesConstants.SYSTEM_FILTER_STRING;
    constructor(http) {
        this.http = http;
    }
    getModuleRoles(moduleId, tableItem) {
        const params = {
            $filter: `${this.moduleIdFilter} ${moduleId} AND ${this.systemFilter}`,
            $orderby: "role"
        };
        return this.http.get(this.moduleRoleUrl, { params }).pipe(map((response) => {
            if (tableItem) {
                response.value.forEach((item) => {
                    tableItem.push(item);
                });
            }
            return response.value;
        }));
    }
    addModuleRole(request) {
        return this.http.post(this.moduleRoleUrl, request);
    }
    updateModuleRole(moduleRole) {
        const request = {
            role: moduleRole.role,
        };
        return this.http.patch(`${this.moduleRoleUrl}/${moduleRole.id}`, request);
    }
    removeModuleRole(id) {
        return this.http.delete(`${this.moduleRoleUrl}/${id}`);
    }
    getModuleRolesAndUsers(moduleId, tableItem) {
        const params = {
            $filter: `${this.moduleIdFilter} ${moduleId} AND ${this.systemFilter}`,
            $expand: "Users",
            $orderby: "role"
        };
        return this.http.get(`${this.moduleRoleUrl}${AppRoutingConstants.ROUTE_SEPERATOR}${this.functionGetModuleRolesAndUsers}`, { params }).pipe(map((response) => {
            if (tableItem) {
                response.value.forEach((item) => {
                    tableItem.push(item);
                });
            }
            return response.value;
        }));
    }
    getModuleRoleAndUsersIncludingSysAdmin(moduleId, tableItem) {
        const params = {
            $filter: `${this.moduleIdFilter} ${moduleId} AND ${this.systemFilter}`,
            $expand: "Users",
            $orderby: "role"
        };
        return this.http.get(`${this.moduleRoleUrl}${AppRoutingConstants.ROUTE_SEPERATOR}${this.functionGetModuleRolesAndUsersIncludingSysAdmin}`, { params }).pipe(map((response) => {
            if (tableItem) {
                response.value.forEach((item) => {
                    tableItem.push(item);
                });
            }
            return response.value;
        }));
    }
    getModuleUsersIncludingSysAdmin(moduleId) {
        const params = {
            moduleId
        };
        return this.http.get(`${this.moduleRoleUrl}${AppRoutingConstants.ROUTE_SEPERATOR}${this.functionGetModuledUsersIncludingSysAdmin}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ModuleRoleService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ModuleRoleService);
export { ModuleRoleService };
